import { ThemeOptions } from '@mui/material';

export const RunaTheme: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#a1e471',
      contrastText: '#0e121b',
    },
    secondary: {
      main: '#20c075',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff5252',
      contrastText: '#ffffff',
    },
    info: {
      main: '#2f415b',
      contrastText: '#ffffff',
    },
    altSurface: {
      main: '#4e4f54',
      contrastText: '#ffffff',
    },
    altSurfaceHover: {
      main: '#62636a',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    allVariants: {
      fontFamily: 'Roboto',
    },
    button: {
      fontWeight: 700,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: '48px',
          fontSize: `var(--text-body-size, 16px)`,
          textTransform: 'initial',
        },
      },
      defaultProps: {
        variant: 'contained',
        color: 'primary',
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '14px 16px',
        },
        notchedOutline: {
          borderColor: 'transparent',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: '#181b20',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            transitionDelay: '999999s',
            transitionProperty: 'background-color, color',
          },
        },
      },
    },
  },
};
